import { Component, effect, inject, input, output } from '@angular/core';
import {
  GcButtonComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { FeedbackAlertService } from '../../../../../shared/feedback-alert/service/feedback-alert.service';
import { SignatureDataService } from '../../../../../shared/signature/service/signature-data/signature-data.service';
import { ScreenSizeClassComponent } from '../../../../../shared/util/screen-size/screen-size.component';
import { ContactInformation } from '../../../../entities/installation-reporting-mdu-details.entities';
import { SigningInformationV2Response } from '../../model/installation-reporting-mdu-bff.entities';

@Component({
  selector: 'app-building-signing-card',
  imports: [GcTextComponent, GcButtonComponent, IpoTranslatePipe],
  templateUrl: './building-signing-card.component.html',
  styleUrl: './building-signing-card.component.scss',
})
export class BuildingSigningCardComponent extends ScreenSizeClassComponent {
  private readonly signatureDataService = inject(SignatureDataService);
  private readonly feedbackAlertService = inject(FeedbackAlertService);

  isReadyForSigning = input(false);
  contact = input<ContactInformation | null>(null);
  signing = input<SigningInformationV2Response | null>(null);
  startSigning = output<void>();

  downloadPdfLoadingState = this.signatureDataService.downloadPdfLoadingState;

  constructor() {
    super();
    effect(() => this.handleFeedbackAlert());
  }

  handleDownloadPdf(fileId: string, fileName: string) {
    this.signatureDataService.downloadPdf(fileId, fileName, {
      useMduFileApi: true,
    });
  }

  private handleFeedbackAlert() {
    if (this.downloadPdfLoadingState()) {
      this.feedbackAlertService.showAlert(
        'success',
        'feedbackAlert.get.preparingDownload',
      );
    } else {
      this.feedbackAlertService.hideAlert();
    }
  }
}
